<template>
  <div class="currency-icon-row">
    <div
      v-for="(country, idx) in visibleCountries"
      :key="country.name"
      class="flag-circle"
    >
      <img :src="country.flag_icon" :alt="country.code" />
    </div>

    <div v-if="remainingCount > 0" class="flag-circle more">
      +{{ remainingCount }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  countries: [],
  maxVisible: {
    type: Number,
    default: 3,
  },
});

// Destructure countries from props
const { countries } = props;

const visibleCountries = computed(() => {
  if (!props.countries || typeof props.countries !== "object") return [];
  const countriesArray = Object.values(props.countries);
  return countriesArray.slice(0, props.maxVisible);
});

const remainingCount = computed(() => {
  if (!props.countries || typeof props.countries !== "object") return 0;
  const countriesArray = Object.values(props.countries);
  return Math.max(0, countriesArray.length - props.maxVisible);
});
</script>

<style scoped>
.currency-icon-row {
  display: flex;
  align-items: center;
  gap: 0px;
}

.flag-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -5px;
}

.flag-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.flag-circle.more {
  background-color: #f2f4f7;
  border: 1px solid #dfe0e3;
  outline: 2px solid #ffffff;
  color: #475467;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 150% */
  width: 26px;
  height: 26px;
}
</style>
